import { getAllHangerPrices } from './hangerPriceActions';
import { getAllLumberPrices, getLumberInventory } from './lumberPriceActions';
import { getAllPlatePrices, getPlateTypeProperties } from './platePriceActions';
import { ThunkActionVoid } from './thunkActions';

export default (): ThunkActionVoid => (dispatch) => {
  dispatch(getAllLumberPrices());
  dispatch(getAllPlatePrices());
  dispatch(getAllHangerPrices());
  dispatch(getPlateTypeProperties());
  dispatch(getLumberInventory());
};
